import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import store from "../store/index";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  theme: {
    dark: store.state.darkMode,
    customProperties: true,
    themes: {
      light: {
        primary:'#4aabff',
        secondary: "#000",
        body:"#fff",
        accent: "#8c9eff",
        error: "#b71c1c",
        success: "#d6f1c7",
        green:"#c0e4b9",
        darkGreen:"#91dd67",
        grayText: "#717171",
        warning:"#f5f5d1",

      },
      dark: {
        primary: "#55c0b4",
        black: "#fff",
        success: "#55c0b4",
        secondary: "#0c1939",
      },
    },
  },
});
